import * as w from '@packages/systems/wfdl';
import * as q from '@packages/systems/wfdl-Qualified';
import * as ast from '@packages/systems/wfdl-ast';
import {ElementSlotIcon, AddPanelSlot64Icon} from '@packages/systems/spring';
import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';
import {
  toOperandExpr,
  TOperand,
} from '@packages/systems/plugins/ConditionsOperand';
import {
  TPredicate,
  toBooleanTag,
} from '@packages/systems/plugins-utils/Boolean';
import {withSystem} from '@packages/systems/wfdl';
import {functionOf, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {qualify, pluginName, typeName} from '@packages/systems/wfdl-Qualified';

import Slot from './Slot';
import {SlotContent} from './dataTypes/SlotContent';

export * from './utils';

const AddPanelSlot = wrapAddPanelIcon(AddPanelSlot64Icon);

const slotPlugin = w.Plugins.name('Slots');

const TSlotContent = TTypeConstructor(
  qualify(pluginName('Slots'), typeName('SlotContent'))
);

const showInsideComponentRoot = ({
  isInsideComponentRoot,
}: {
  isInsideComponentRoot: boolean;
}) => {
  return isInsideComponentRoot ? 'Structure' : null;
};

export const plugin = w.Plugins.PrivilegedPlugin({
  icons: {
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelSlot,
    Slot: ElementSlotIcon,
  },
  atoms: {Slot},
  dataTypes: {SlotContent},
  values: {
    SlotCondition: {
      envType: {
        dataType: functionOf(TSlotContent, TOperand(TSlotContent)),
        exported: 'visible',
        implicit: 'prefilledArgs',
      },
      expression: toOperandExpr,
    },
    SlotIsEmpty: {
      envType: {
        exported: 'hidden',
        dataType: withSystem({label: 'is empty'}, TPredicate(TSlotContent)),
      },
      value: (list: unknown[]) => toBooleanTag(!list || list.length === 0),
    },
    SlotIsNotEmpty: {
      envType: {
        exported: 'hidden',
        dataType: withSystem({label: 'is not empty'}, TPredicate(TSlotContent)),
      },
      value: (list: unknown[]) => toBooleanTag(list && list.length > 0),
    },
  },
  elementPresets: {
    Slot: w.ElementPreset.create({
      label: 'Slot',
      category: showInsideComponentRoot,
      helpData: {
        description: [
          'A Slot is a flexible placeholder within a Component, allowing you to customize specific content areas without impacting the overall design of the Component.',
        ],
        tip: 'Edit slots quickly by double-clicking on a Component. Note that modifying the contents of a Slot in one instance doesn’t change other instances.',
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/slot-v1.95a035a964.mp4',
        tag: 'div',
      },
      icon: {
        medium: q.qualify(slotPlugin, q.iconName('AddPanelSlot')),
        small: q.qualify(slotPlugin, q.iconName('Slot')),
      },
      factory: ast.EElement({
        id: 'Slot',
        type: q.qualify(slotPlugin, w.Component.name('Slot')),
        data: ast.ERecord({
          name: ast.EText(''),
          slot: ast.EText(''),
          children: ast.EList([]),
          tag: ast.EEnum('div'),
          allowedComponents: ast.EList([]),
        }),
      }),
    }),
  },
});
